angular.module("ainapp")
    .controller("CustomDesignController", ["app.config", "$scope", "LoginService", "AuthenticationService", "$state", "$stateParams", "MainService", "localStorageService",
        function (config, $scope, LoginService, AuthenticationService, $state, $stateParams, MainService, localStorageService) {

            $scope.PageName = "Custom Design";
            $scope.TokenInfo = AuthenticationService.getTokenInfo();
            if ($scope.TokenInfo == null) {
                $state.go("login");
            } else {
                $scope.checkUserPageAccess($scope.PageName);
            }


            $scope.Init = function () {

                $scope.load = false;
                $scope.VoucherDesign = {};

                $.LoadingOverlay("show", {
                    image: "images/load.gif",
                });

                MainService.CustomDesignsbyType("Customer").then(function (response) {
                    if(response.data != null && response.data != ""){
                        $scope.VoucherDesign = response.data;
                    }
                    $.LoadingOverlay("hide");
                }, function (err) {
                    toastr.error("Network Error");
                    $scope.load = false;
                    $.LoadingOverlay("hide");
                })


                $scope.ViewVal = 0;
                $scope.SelectedType = "Customer";

            }
            $scope.Init();

            $scope.selectType = function (val, type) {

                $scope.ViewVal = val;
                $scope.SelectedType = type;

                $.LoadingOverlay("show", {
                    image: "images/load.gif",
                });

                MainService.CustomDesignsbyType(type).then(function (response) {
                    if(response.data != null && response.data != ""){
                        $scope.VoucherDesign = response.data;
                    }else{
                        $scope.VoucherDesign =  {};
                    }
                    $.LoadingOverlay("hide");
                }, function (err) {
                    toastr.error("Network Error");
                    $scope.load = false;
                    $.LoadingOverlay("hide");
                })


            }


            $scope.SaveData = function () {
                $.LoadingOverlay("show", {
                    image: "images/load.gif",
                });
                $scope.load = true;
                $scope.VoucherDesign.Type = $scope.SelectedType;
                MainService.AddCustomDesign($scope.VoucherDesign).then(function (response) {
                    $scope.load = false;
                    if (response) {
                        toastr.success("Success");
                        $scope.Init();
                    }
                    else{
                        $scope.VoucherDesign =  {};
                    }
                    $.LoadingOverlay("hide");
                }, function (err) {
                    toastr.error("Network Error");
                    $scope.load = false;
                    $.LoadingOverlay("hide");
                })

            }



        }]);
